import { Menu, MenuProps } from 'antd'
import { observer } from 'mobx-react-lite'
import { FC, useContext, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import { Context } from '..'
import useWindowDimensions from '../core/hooks/useWindowDimensions'
import { LOCALES } from '../core/i18n/locales'
import { StorageKeys } from '../core/utils/defaults'
import { isNullOrUndefined, translit } from '../core/utils/utils'
import OptionsModal from '../pages/_shared/OptionsModal/OptionsModal'

import iconStyles from '../styles/Icon.module.scss'
import styles from '../styles/Header.module.scss'
import { Icon } from './icons/Icon'

type MenuItem = Required<MenuProps>['items'][number]

function getItem(
	label: React.ReactNode,
	key: React.Key,
	icon?: React.ReactNode,
	children?: MenuItem[],
	type?: 'group'
): MenuItem {
	return {
		key,
		icon,
		children,
		label,
		type,
	} as MenuItem
}

const Header: FC = () => {
	const { formatMessage: f } = useIntl()

	const { store, shopStore, studioStore, adminStore } = useContext(Context)
	const { width, height } = useWindowDimensions()
	const navigate = useNavigate()
	const location = useLocation()

	const [menuPreOpenned, setMenuPreOpenned] = useState(true)
	const [searchGoVisible, setSearchGoVisible] = useState(false)

	const [headerToggled, setHeaderToggled] = useState(true)
	const [headerTgl, setHeaderTgl] = useState(false)

	const [isMenuShown, setIsMenuShown] = useState(false)
	const [isMenuVisible, setIsMenuVisible] = useState(false)
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	const [items, setItems] = useState([] as MenuProps['items'])

	const [selectedCountry, setSelectedCountry] = useState([] as any)

	const onMouseUp = (e: any) => {
		var container = document.getElementById('ddp_menu')

		if (container != null && !container.contains(e.target)) {
			//container.style.display = 'none'
			closeMenu()
		}
	}

	const openMenu = () => {
		setIsMenuShown((prev) => (prev = true))
		// if (width < 1280) {
		// document.getElementById("root")!.style.overflowY = "hidden"
		// document.getElementsByTagName("html")[0].style.overflowY = "hidden"
		// document.body.style.overflowY = "hidden"

		// document.addEventListener('mouseup', onMouseUp)
		// }
		setIsMenuVisible((prev) => (prev = true))
		setTimeout(() => {
			setIsMenuOpen((prev) => (prev = true))
		}, 100)
	}

	const closeMenu = () => {
		setIsMenuOpen((prev) => (prev = false))
		// if (width < 1280) {
		// document.getElementById("root")!.style.overflowY = "scroll"
		// document.getElementsByTagName("html")[0].style.overflowY = "hidden"
		// document.body.style.overflowY = "hidden"

		// document.removeEventListener('mouseup', onMouseUp)
		// }
		setTimeout(() => {
			setIsMenuVisible((prev) => (prev = false))
			setIsMenuShown((prev) => (prev = false))
		}, 300)
	}

	const goTop = () => {
		if (store.menuSelected != 0) {
			store.setIsHomeBlockVisible(false)
			store.setIsHeaderLocked(false)
			store.setSelectedSlide(0)
			setTimeout(() => {
				store.setMenuSelected(0)
				setTimeout(() => {
					store.setIsHomeBlockVisible(true)
				}, 100)
			}, 200)
		}

		const section = document.querySelector(`#top`)
		if (!isNullOrUndefined(section)) {
			section.scrollIntoView({
				behavior: 'smooth',
			})
		}
	}

	const navTo = (event: any) => {
		event.preventDefault()
		event.stopPropagation()

		let path = ''

		if (event.target.nodeName.toLowerCase() == 'img') {
			path = event.target.parentElement.pathname
		} else {
			path = event.target.pathname
		}

		if (path == location.pathname) {
			return
		}

		store.setIsFaderVisible(true)
		setTimeout(() => {
			store.setIsFaderShown(true)

			window.scroll(0, 0)

			setTimeout(() => {
				navigate(path)
			}, 300)
		}, 100)
	}

	const isHeaderBg = () => {
		return location.pathname == '/contacts' || location.pathname == '/about'
	}

	const runAnimations = () => {
		const logo = document.getElementById('logo')
		const open = document.getElementById('open')
		const menu1 = document.getElementById('menu1')
		const menu2 = document.getElementById('menu2')
		const menu3 = document.getElementById('menu3')
		const menu4 = document.getElementById('menu4')
		const menu5 = document.getElementById('menu5')
		const soc1 = document.getElementById('soc1')
		const soc2 = document.getElementById('soc2')
		const act1 = document.getElementById('act1')

		if (logo != null) {
			logo.style.opacity = '1'
		}

		if (open != null) {
			setTimeout(() => {
				open.style.opacity = '1'
			}, 200)
		}

		if (menu1 != null && menu2 != null && menu3 != null && menu4 != null && menu5 != null) {
			setTimeout(() => {
				menu1.style.opacity = '1'
				setTimeout(() => {
					menu2.style.opacity = '1'
					setTimeout(() => {
						menu3.style.opacity = '1'
						setTimeout(() => {
							menu4.style.opacity = '1'
							setTimeout(() => {
								menu5.style.opacity = '1'
							}, 60)
						}, 60)
					}, 60)
				}, 60)
			}, 100)
		}

		if (soc1 != null && soc2 != null && act1 != null) {
			act1.style.opacity = '1'
			setTimeout(() => {
				soc1.style.opacity = '1'
				setTimeout(() => {
					soc2.style.opacity = '1'
				}, 100)
			}, 100)
		}
	}

	const openForm = (title: string) => {
		store.setFormTitle(title)
		store.setIsFormVisible(true)
		closeMenu()
	}

	useEffect(() => {
		let scrFix = 0

		setTimeout(() => {
			runAnimations()
		}, 100)

		const onScroll = (event: any) => {
			const scrollTop = event.target.scrollTop

			// if (width <= 960 && location.pathname == "/") {
			//   return
			// }

			if (scrollTop >= 60) {
				store.setIsHeaderLocked(true)
			} else {
				store.setIsHeaderLocked(false)
			}

			if (scrollTop < scrFix && scrollTop > store.xScr) {
				setHeaderToggled((prev) => (prev = true))
			} else if (scrollTop > store.xScr) {
				setHeaderToggled((prev) => (prev = false))
			}

			scrFix = parseInt(`${scrollTop}`)

			if (location.pathname.includes('/projects') && store.selectedProject != null) {
				if (scrollTop > window.innerHeight - 50) {
					setHeaderTgl((prev) => (prev = true))
				} else {
					setHeaderTgl((prev) => (prev = false))
				}
			} else {
				setHeaderTgl((prev) => (prev = false))
			}
		}

		shopStore.getGlobalSearchText()

		document.getElementById('root')!.addEventListener('scroll', onScroll)

		return () => {
			document.getElementById('root')!.removeEventListener('scroll', onScroll)
		}
	}, [])

	useEffect(() => {
		if (studioStore?.selCountry?.name) setSelectedCountry(studioStore.selCountry)
	}, [studioStore?.selCountry?.name])

	return (
		<>
			<div
				className={styles.menu_wrap}
				style={{
					display: isMenuVisible ? 'block' : 'none',
					opacity: isMenuOpen ? '1' : '0',
				}}
			>
				<div className={styles.logo}>
					<a href='/'>PODCASTBERY</a>
				</div>
				<div className={styles.close} onClick={() => closeMenu()}>
					<Icon variant={'xmark'} className={iconStyles.header_xmark} />
				</div>
				<div className={styles.menu_items}>
					{/* <a className={styles.menu_items__item + (location.pathname == '/' ? ' ' + styles.active : '')} href='/'>
						<FormattedMessage id='head_home' />
					</a> */}
					<a className={styles.menu_items__item + (location.pathname == '/' ? ' ' + styles.active : '')} href='/'>
						<FormattedMessage id='head_studios' />
					</a>
					{/* <a className={styles.menu_items__item + (location.pathname.includes("/franchises") ? " " + styles.active : "")} href="/franchises"><FormattedMessage id="head_franchises" /></a> */}
					<a
						className={styles.menu_items__item + (location.pathname.includes('/connect') ? ' ' + styles.active : '')}
						href='/connect'
					>
						<FormattedMessage id='head_partners' />
					</a>
					<a
						className={styles.menu_items__item + (location.pathname.includes('/about') ? ' ' + styles.active : '')}
						href='/about'
					>
						<FormattedMessage id='head_about' />
					</a>
					{/* <a className={styles.menu_items__item + (location.pathname.includes("/blog") ? " " + styles.active : "")} href="/blog">Блог</a>
          				<a className={styles.menu_items__item + (location.pathname.includes("/podcasts") ? " " + styles.active : "")} href="/podcasts">Подкасты</a> */}
					{/* <a className={styles.menu_items__item + (location.pathname.includes("/about") ? " " + styles.active : "")} href="/about">О проекте</a> */}

					<a
						className={styles.menu_items__item + (location.pathname.includes('/account') ? ' ' + styles.active : '')}
						href='/account'
					>
						<FormattedMessage id='head_cabinet' />
					</a>
				</div>
				{/* <div className={styles.socials}>
					<a href='https://vk.com/podcastbery' rel='nofollow' target='_blank'>
						<Icon variant={'vk'} className={iconStyles.header_socials} />
					</a>
					<a href='https://t.me/podcastbery' rel='nofollow' target='_blank'>
						<Icon variant={'telegram'} className={iconStyles.header_socials} />
					</a>
				</div> */}
			</div>

			<header
				className={styles.header + ' ' + styles[store.headerTheme] + (store.isHeaderLocked ? ' ' + styles.fixed : '')}
			>
				<div
					className={location.pathname.includes('/partner') ? 'container2' : 'container'}
					style={
						location.pathname.includes('/partner')
							? {
									maxWidth: '95%',
									margin: '0 auto',
								}
							: {}
					}
				>
					<div className={styles.mainHeaderContainer}>
						<div className={styles.headerContainer}>
							<div style={{ position: 'relative', height: store.isMobile ? '70px' : '82px', width: '100%' }}>
								<div className={styles.logo_container}>
									<a href='/' className={styles.logo}>
										<FormattedMessage id='studios_srch_caps' />
									</a>
									{width > 960 ? (
										<div className={styles.ended_wrap}>
											{studioStore.selCountry != null ? (
												<div className={styles.ctry} onClick={() => studioStore.setIsCtrVisible(true)}>
													<div>
														{store.locale == 'ru-RU' ? studioStore.selCountry.name : studioStore.selCountry.name_en}
													</div>
													<div>
														<Icon variant={'caret_down'} className={iconStyles.default} />
													</div>
												</div>
											) : (
												<></>
											)}
										</div>
									) : (
										<></>
									)}
								</div>
							</div>
							{width > 960 ? (
								<div className={styles.flexed_center}>
									<div className={styles.menu}>
										<a href='/' className={location.pathname == '/' ? styles.active : ''}>
											<FormattedMessage id='head_studios' />
										</a>
										<a href='/connect' className={`${location.pathname.includes('/connect') ? styles.active : ''}`}>
											<FormattedMessage id='head_partners' />
										</a>

										<a href='/about' className={location.pathname.includes('/about') ? styles.active : ''}>
											<FormattedMessage id='head_about' />
										</a>
									</div>
								</div>
							) : (
								<></>
							)}
							{width > 960 ? (
								<div className={styles.ended_wrap}>
									{/* <div className={styles.socials_pc}>
										<a href='https://vk.com/podcastbery' rel='nofollow' target='_blank'>
											<Icon variant={'vk'} className={iconStyles.header_socials} />
										</a>
										<a href='https://t.me/podcastberyy' rel='nofollow' target='_blank'>
											<Icon variant={'telegram'} className={iconStyles.header_socials} />
										</a>
									</div> */}
									{store.isAuth ? (
										<div className={styles.account_btns}>
											<a href='/account'>
												<FormattedMessage id='head_cabinet' />
											</a>
										</div>
									) : (
										<div className={styles.account_btns}>
											<a href='/signin'>
												<FormattedMessage id='head_login' />
											</a>
											<a href='/signup'>
												<FormattedMessage id='head_signup' />
											</a>
										</div>
									)}
								</div>
							) : (
								<></>
							)}
							{width < 960 ? (
								<div className={styles.ended_wrap}>
									<button className={styles.menu_btn} onClick={() => openMenu()}>
										<Icon variant={'bars'} className={iconStyles.default} />
									</button>

									{studioStore.selCountry != null ? (
										<div className={styles.ctry} onClick={() => studioStore.setIsCtrVisible(true)}>
											<div>
												{store.locale == 'ru-RU' ? studioStore.selCountry.name : studioStore.selCountry.name_en}
											</div>
											<div>
												<Icon variant={'caret_down'} className={iconStyles.default} />
											</div>
										</div>
									) : (
										<></>
									)}
								</div>
							) : (
								<></>
							)}
						</div>
						<div className={styles.divider}></div>
					</div>
				</div>
			</header>

			<OptionsModal
				height='auto'
				openned={studioStore.isCtrVisible}
				title={f({ id: 'select_country' })}
				onClose={() => studioStore.setIsCtrVisible(false)}
				done={f({ id: 'select_option' })}
				onDone={() => {
					studioStore.setSelCountry(selectedCountry)
					studioStore.setSelCountryName(selectedCountry.name)

					localStorage.setItem(StorageKeys.COUNTRY, JSON.stringify(selectedCountry))
					setTimeout(() => {
						window.location.href = `https://${selectedCountry.domain}`
					}, 300)
				}}
			>
				<div className='cities_selecting'>
					{studioStore.countries.map((ctr) => (
						<div
							key={ctr.id}
							className={'cs_item' + (selectedCountry != null && selectedCountry.name == ctr.name ? ' selected' : '')}
							onClick={() => {
								setSelectedCountry(ctr)
							}}
						>
							<div className='cs_item__name'>{store.locale == 'ru-RU' ? ctr.name : ctr.name_en}</div>
							<div className='cs_item__check'>
								<span>
									<Icon variant={'check'} className={iconStyles.city_check} />
								</span>
							</div>
						</div>
					))}
				</div>
			</OptionsModal>
		</>
	)
}

export default observer(Header)
